import { useTranslation } from 'react-i18next'
import { useToast } from '@/hooks/use-toast'
import { useActivateSequence } from '@/hooks/useApi'
import type { Sequence } from '@/types/api'

/**
 * Activate a sequence with the no-sender guard shared by list and detail:
 * without a sender account the activation is refused with an explicit toast
 * (mirroring the backend rule) instead of failing silently; API errors are
 * surfaced with the same toast.
 */
export function useActivateSequenceGuarded() {
  const { t } = useTranslation('sequences')
  const { toast } = useToast()
  const activateSequence = useActivateSequence()

  const activate = (sequence: Sequence) => {
    if (!sequence.email_account_id) {
      toast({
        variant: 'destructive',
        title: t('detail.cannotActivate'),
        description: t('noSender.activateBlocked'),
      })
      return
    }
    activateSequence.mutate(sequence.id, {
      onError: (error) => {
        toast({
          variant: 'destructive',
          title: t('detail.cannotActivate'),
          description: error.message,
        })
      },
    })
  }

  return { activate, isPending: activateSequence.isPending }
}
